// extracted by mini-css-extract-plugin
export default {"equilateral":"ShapeWrapper_equilateral__5vjI0","square":"ShapeWrapper_square__JjVhB","inner":"ShapeWrapper_inner__Ta6GK","circle":"ShapeWrapper_circle__Uky4D"};